import { IconComponent } from './types';

const LineIcon: IconComponent = (props) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_615_6277"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="12"
        height="12"
      >
        <rect width="12" height="12" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_615_6277)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.72006 4.47395L7.83961 8.11343L11.1484 4.80459L11.4878 5.144L7.8125 8.81937L4.6712 5.15451L0.67976 8.64702L0.363678 8.28578L4.72006 4.47395Z"
          fill="currentColor"
        />
        <path
          d="M0.782607 7.42295C1.21483 7.42295 1.56521 7.77334 1.56521 8.20556C1.56521 8.63778 1.21483 8.98817 0.782607 8.98817C0.350385 8.98817 0 8.63778 0 8.20556C0 7.77334 0.350385 7.42295 0.782607 7.42295Z"
          fill="currentColor"
        />
        <path
          d="M7.78258 7.42295C8.2148 7.42295 8.56518 7.77334 8.56518 8.20556C8.56518 8.63778 8.2148 8.98817 7.78258 8.98817C7.35035 8.98817 6.99997 8.63778 6.99997 8.20556C6.99997 7.77334 7.35035 7.42295 7.78258 7.42295Z"
          fill="currentColor"
        />
        <path
          d="M4.6956 3.99998C5.12782 3.99998 5.47821 4.35037 5.47821 4.78259C5.47821 5.21481 5.12782 5.5652 4.6956 5.5652C4.26338 5.5652 3.91299 5.21481 3.91299 4.78259C3.91299 4.35037 4.26338 3.99998 4.6956 3.99998Z"
          fill="currentColor"
        />
        <path
          d="M11.2174 4.11821C11.6496 4.11821 12 4.4686 12 4.90082C12 5.33304 11.6496 5.68342 11.2174 5.68342C10.7852 5.68342 10.4348 5.33304 10.4348 4.90082C10.4348 4.4686 10.7852 4.11821 11.2174 4.11821Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default LineIcon;
